import { render, staticRenderFns } from "./OnlineMoneyTransfers.vue?vue&type=template&id=3ab520af&scoped=true"
import script from "./OnlineMoneyTransfers.vue?vue&type=script&lang=js"
export * from "./OnlineMoneyTransfers.vue?vue&type=script&lang=js"
import style0 from "./OnlineMoneyTransfers.vue?vue&type=style&index=0&id=3ab520af&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ab520af",
  null
  
)

export default component.exports